import React from 'react';
const { useState, useEffect } = React;
import { LABELS } from '../../expenseSchema.js';
import { expensesCall, expenseErrorText, fmtMoney, fmtDay, openExpense } from '../../expensesClient.js';

// Hoy › gastos por vencer: the open expenses (business and personal) overdue or due within 7 days, and operations left
// incomplete, read from the same records as Finanzas › Gastos (no task is created). At most 5 rows; more is one line.
const muted = { fontSize: 12, color: 'var(--globant-muted)' };
export default function ExpensesDue({ today }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');
  const load = () => { setError(''); expensesCall('due').then(r => setItems(r.items)).catch(e => setError(expenseErrorText(e))); };
  useEffect(load, []);
  if (error) return <div role="alert" style={{ ...muted, margin: '8px 0' }}>No se pudieron leer los gastos por vencer: no significa que no haya. <button type="button" className="action-btn" style={{ fontSize: 11 }} onClick={load}>Reintentar</button></div>;
  if (!items || !items.length) return null;
  const row = (x) => {
    const s = x.state;
    const overdue = s.dueOn && s.dueOn < today;
    const note = s.intent?.kind === 'payment' ? 'operación incompleta' : s.review.includes('unconfirmed_payment') ? 'pago sin confirmar' : s.intent?.kind === 'other_currency' ? `pago en ${s.intent.currency} no soportado` : '';
    return (
      <div key={x.id} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'baseline', fontSize: 13 }}>
        <span style={{ fontSize: 10.5, fontWeight: 700, textTransform: 'uppercase', color: x.scope === 'personal' ? 'var(--area-private, #6B5CA5)' : 'var(--area-business, #6B4510)' }}>{LABELS.scope[x.scope]}</span>
        <span style={{ flex: '1 1 200px', minWidth: 0 }}>{x.supplier} · {x.concept}</span>
        <b style={{ fontVariantNumeric: 'tabular-nums' }}>{fmtMoney(s.pending ?? x.amount, x.currency)}</b>
        <span style={{ ...muted, color: overdue ? '#B4362C' : muted.color }}>{s.dueOn ? `${overdue ? 'venció' : 'vence'} ${fmtDay(s.dueOn)}` : ''}{note ? `${s.dueOn ? ' · ' : ''}${note}` : ''}</span>
        <button type="button" className="action-btn" style={{ fontSize: 11 }} onClick={() => openExpense(x.scope, x.id)}>Abrir</button>
      </div>
    );
  };
  return (
    <section aria-label="Gastos por vencer" className="card" style={{ padding: '10px 12px', margin: '10px 0', display: 'grid', gap: 6 }}>
      <b style={{ fontSize: 13 }}>Gastos por vencer</b>
      {items.length > 5
        ? <div style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 13 }}><span style={{ flex: 1 }}>{items.length} gastos vencidos o por vencer en los próximos 7 días.</span><button type="button" className="action-btn" style={{ fontSize: 11 }} onClick={() => window.dispatchEvent(new CustomEvent('oike:navigate', { detail: { page: 'expenses' } }))}>Ver en Gastos</button></div>
        : items.map(row)}
    </section>
  );
}
